import React from 'react';
import { Route, IndexRedirect } from 'react-router';

import OverviewPage from './pages/OverviewPage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';
import AccessDeniedPage from './pages/AccessDeniedPage'
import LoginPage from './pages/LoginPage';
import ObjectManagementPage from './pages/ObjectManagementPage'
import CustomerDisplayPage from './pages/CustomerDisplayPage'
import AppLoader from './components/AppLoader'
import ClearCachePage from './pages/ClearCachePage'
import KioskPage from './pages/KioskPage'
import ChargingKioskPage from './pages/ChargingKioskPage'
import ProductionPage from './pages/ProductionPage'
import TicketScannerPage from './pages/TicketScannerPage'

export default (
  <Route path="/">
    <IndexRedirect to="/login" />
    <Route path="/clear" component={ClearCachePage} />
    <Route path="/" component={AppLoader}>
      <IndexRedirect to="/login" />
      <Route path="/login" component={LoginPage} />
      <Route path="/overview" component={OverviewPage} />
      <Route path="/about" component={AboutPage} />
      <Route path="/accessdenied" component={AccessDeniedPage} />
      <Route path="/apploader" component={AppLoader} />
      <Route path="/objectmanagement" component={ObjectManagementPage} />
      <Route path="/customerdisplay" component={CustomerDisplayPage} />
      <Route path="/kiosk" component={KioskPage} />
      <Route path="/chargingkiosk" component={ChargingKioskPage} />
      <Route path="/ticketscanner" component={TicketScannerPage} />
      <Route path="/production" component={ProductionPage} />
      <Route path="*" component={NotFoundPage} />
    </Route>
  </Route>
)



// WEBPACK FOOTER //
// src/routes.js